import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { makeGetCurrentUser } from '../selectors/users';
import { makeGetLibraryCustomFields } from '../selectors/custom-fields';
import { makeGetFetchedStateWithoutId, makeGetLoadingStateWithoutId } from '../selectors/global';

import { fetchCustomFields } from '../actions/custom-fields';

import CustomFieldCard from './custom-field-card';

class CustomFieldsLibrary extends PureComponent {
    attemptFetch() {
        if (this.props.fetched || this.props.loading) {
            return;
        }

        fetchCustomFields();
    }

    componentDidMount() {
        this.attemptFetch();
    }

    componentDidUpdate() {
        this.attemptFetch();
    }

    render() {
        const { t } = this.props;

        if (!this.props.customFields.length) {
            return <p className="dimmed-text">{ t('Saved custom fields will be accessible here') }</p>
        }

        return (
            <div className="custom-fields-card-list">
                {
                    this.props.customFields.map(field => <CustomFieldCard key={field.id} id={field.id} onSelect={this.props.onSelect} />)
                }
            </div>
        );
    }
}

const makeMapStateToProps = () => {
    const getCurrentUser = makeGetCurrentUser();
    const getLibraryCustomFields = makeGetLibraryCustomFields();
    const getCustomFieldsFetched = makeGetFetchedStateWithoutId();
    const getCustomFieldsLoading = makeGetLoadingStateWithoutId();

    return ({ users, customFields }, ownProps) => {
        const currentUser = getCurrentUser(users);

        return {
            customFields: getLibraryCustomFields(customFields.items, currentUser.role),
            fetched: getCustomFieldsFetched(customFields.fetchInfo, 'team'),
            loading: getCustomFieldsLoading(customFields.fetchInfo, 'team')
        }
    }
}

export default connect(makeMapStateToProps)(withTranslation('fields')(CustomFieldsLibrary));
